import { render } from "./CourseExamDetails.vue?vue&type=template&id=1f807a53"
import script from "./CourseExamDetails.vue?vue&type=script&lang=js"
export * from "./CourseExamDetails.vue?vue&type=script&lang=js"

import "./CourseExamDetails.vue?vue&type=style&index=0&id=1f807a53&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__